import { render, staticRenderFns } from "./EmployerSupport.vue?vue&type=template&id=834bd1bc&scoped=true"
import script from "./EmployerSupport.vue?vue&type=script&lang=ts"
export * from "./EmployerSupport.vue?vue&type=script&lang=ts"
import style0 from "./EmployerSupport.vue?vue&type=style&index=0&id=834bd1bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "834bd1bc",
  null
  
)

export default component.exports